// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__19SXu","body":"style_body__9PGWp","nav":"style_nav__6jW-t","header":"style_header__Zk6dz"};